import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ColorPickerEditor from 'common/components/ColorPicker';

import {
    setFormFieldsInputBackgroundColorDefault,
    setFormFieldsInputBackgroundColorHover,
} from 'common/entities/form/styleConfiguration/actions';
import { DEFAULT_INPUT_BACKGROUND_COLOR } from 'common/entities/form/styleConfiguration/defaultValues';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import { getFormInputBackgroundColors } from 'common/entities/form/styleConfiguration/selectors';
import { getColors } from 'common/entities/color/selectors';
import { getFormId } from '../../../../selectors';

import { COLOR_PICKER_DEFAULT, COLOR_PICKER_HOVER } from '../../../../constants/formStyleLabels';

import { FORM_FIELDS_QA } from '../../../../utils/qaIdConstants';

const InputBackgroundPanel = ({ formId, defaultColor, hoverColor, colorList, ...props }) => (
    <ColorPickerEditor
        colorList={colorList}
        firstColorLabel={COLOR_PICKER_DEFAULT}
        secondColorLabel={COLOR_PICKER_HOVER}
        firstColor={defaultColor}
        secondColor={hoverColor}
        changeFirstColor={(id) => props.setFormFieldsInputBackgroundColorDefault(formId, id)}
        changeSecondColor={(id) => props.setFormFieldsInputBackgroundColorHover(formId, id)}
        qaId={FORM_FIELDS_QA}
    />
);

InputBackgroundPanel.propTypes = {
    defaultColor: styleShapePropTypes,
    hoverColor: styleShapePropTypes,
    formId: PropTypes.string.isRequired,
    colorList: PropTypes.arrayOf(PropTypes.object).isRequired,
    setFormFieldsInputBackgroundColorDefault: PropTypes.func.isRequired,
    setFormFieldsInputBackgroundColorHover: PropTypes.func.isRequired,
};

InputBackgroundPanel.defaultProps = {
    defaultColor: getDefaultStyle(DEFAULT_INPUT_BACKGROUND_COLOR),
    hoverColor: getDefaultStyle(DEFAULT_INPUT_BACKGROUND_COLOR),
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const colorList = getColors(state);
    const { default: defaultColor, hover: hoverColor } = getFormInputBackgroundColors(state, formId);

    return {
        formId,
        defaultColor,
        hoverColor,
        colorList,
    };
};

const mapDispatchToProps = {
    setFormFieldsInputBackgroundColorDefault,
    setFormFieldsInputBackgroundColorHover,
};

export default connect(mapStateToProps, mapDispatchToProps)(InputBackgroundPanel);
